import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconItalic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconItalic"><Path fillRule="evenodd" clipRule="evenodd" d="M9 3H20V4.5H15.0564L10.511 19.5H15.0101V21H4V19.5H8.94359L13.489 4.5H9V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconItalic;
